import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageSEO from '../components/PageSEO';
import SeoContent from '../components/SeoContent';

const CATEGORY_COLORS = {
  yellow: { bg: '#F9DF6D' },
  green:  { bg: '#A0C35A' },
  blue:   { bg: '#B0C4EF' },
  purple: { bg: '#BA81C5' },
};

const DIFFICULTY_LABEL = {
  yellow: 'Straightforward',
  green:  'Getting Tricky',
  blue:   'Challenging',
  purple: 'Fiendish',
};

const SHARE_EMOJI = { yellow: '🟨', green: '🟩', blue: '🟦', purple: '🟪' };
const COLOR_ORDER = ['yellow', 'green', 'blue', 'purple'];
const MAX_MISTAKES = 4;

const PUZZLES = [
  {
    id: 1,
    categories: [
      { color: 'yellow', name: 'TYPES OF CHEESE',   words: ['BRIE', 'FETA', 'GOUDA', 'EDAM'] },
      { color: 'green',  name: 'PLANETS',            words: ['MARS', 'VENUS', 'SATURN', 'URANUS'] },
      { color: 'blue',   name: '___ BOARD',          words: ['SURF', 'KEY', 'CARD', 'SKATE'] },
      { color: 'purple', name: 'SHADES OF BLUE',     words: ['AZURE', 'COBALT', 'INDIGO', 'NAVY'] },
    ],
  },
  {
    id: 2,
    categories: [
      { color: 'yellow', name: 'MUSICAL INSTRUMENTS',       words: ['FLUTE', 'CELLO', 'BANJO', 'OBOE'] },
      { color: 'green',  name: 'TYPES OF DANCE',            words: ['WALTZ', 'TANGO', 'FOXTROT', 'POLKA'] },
      { color: 'blue',   name: '___ LINE',                  words: ['HAIR', 'BASE', 'HEAD', 'DEAD'] },
      { color: 'purple', name: 'THINGS THAT ARE ALSO COLORS', words: ['ROSE', 'GOLD', 'JADE', 'VIOLET'] },
    ],
  },
  {
    id: 3,
    categories: [
      { color: 'yellow', name: 'HERBS',           words: ['BASIL', 'THYME', 'SAGE', 'MINT'] },
      { color: 'green',  name: 'COOKING METHODS', words: ['BROIL', 'BRAISE', 'SAUTE', 'POACH'] },
      { color: 'blue',   name: 'KITCHEN TOOLS',   words: ['WHISK', 'LADLE', 'TONGS', 'GRATER'] },
      { color: 'purple', name: 'TYPES OF CAKE',   words: ['SPONGE', 'CARROT', 'MARBLE', 'BUNDT'] },
    ],
  },
  {
    id: 4,
    categories: [
      { color: 'yellow', name: 'CAPITAL CITIES', words: ['OSLO', 'LIMA', 'SOFIA', 'CAIRO'] },
      { color: 'green',  name: 'ISLAND NATIONS', words: ['CUBA', 'MALTA', 'FIJI', 'ICELAND'] },
      { color: 'blue',   name: 'CURRENCIES',     words: ['EURO', 'POUND', 'FRANC', 'KRONE'] },
      { color: 'purple', name: 'MAJOR RIVERS',   words: ['NILE', 'THAMES', 'AMAZON', 'GANGES'] },
    ],
  },
  {
    id: 5,
    categories: [
      { color: 'yellow', name: 'TRACK & FIELD EVENTS', words: ['JAVELIN', 'HURDLES', 'DISCUS', 'VAULT'] },
      { color: 'green',  name: 'TEAM SPORTS',          words: ['RUGBY', 'HOCKEY', 'LACROSSE', 'NETBALL'] },
      { color: 'blue',   name: 'SPORTS EQUIPMENT',     words: ['RACKET', 'PUCK', 'SHUTTLECOCK', 'POMMEL'] },
      { color: 'purple', name: 'OVER___',               words: ['BOARD', 'CAST', 'HAUL', 'COAT'] },
    ],
  },
  {
    id: 6,
    categories: [
      { color: 'yellow', name: 'CHEMICAL ELEMENTS', words: ['GOLD', 'IRON', 'LEAD', 'ZINC'] },
      { color: 'green',  name: 'FAMOUS SCIENTISTS', words: ['DARWIN', 'NEWTON', 'CURIE', 'TESLA'] },
      { color: 'blue',   name: 'TYPES OF CLOUD',    words: ['CIRRUS', 'CUMULUS', 'STRATUS', 'NIMBUS'] },
      { color: 'purple', name: '___ WAVE',           words: ['HEAT', 'MICRO', 'TIDAL', 'BRAIN'] },
    ],
  },
  {
    id: 7,
    categories: [
      { color: 'yellow', name: 'SHAKESPEARE PLAYS', words: ['HAMLET', 'OTHELLO', 'MACBETH', 'TEMPEST'] },
      { color: 'green',  name: 'BOOK GENRES',       words: ['THRILLER', 'MYSTERY', 'ROMANCE', 'FANTASY'] },
      { color: 'blue',   name: 'PUNCTUATION MARKS', words: ['COMMA', 'COLON', 'HYPHEN', 'DASH'] },
      { color: 'purple', name: '___ LIGHT',         words: ['MOON', 'LIME', 'CANDLE', 'SPOT'] },
    ],
  },
  {
    id: 8,
    categories: [
      { color: 'yellow', name: 'BABY ANIMALS',      words: ['KITTEN', 'FOAL', 'CYGNET', 'PIGLET'] },
      { color: 'green',  name: 'ANIMAL SOUNDS',     words: ['BRAY', 'BLEAT', 'NEIGH', 'CROAK'] },
      { color: 'blue',   name: 'GROUPS OF ANIMALS', words: ['FLOCK', 'PACK', 'PRIDE', 'SWARM'] },
      { color: 'purple', name: '___ FISH',          words: ['SWORD', 'STAR', 'JELLY', 'CAT'] },
    ],
  },
  {
    id: 9,
    categories: [
      { color: 'yellow', name: 'SHADES OF RED',    words: ['SCARLET', 'CRIMSON', 'MAROON', 'RUBY'] },
      { color: 'green',  name: 'POKER HANDS',      words: ['FLUSH', 'STRAIGHT', 'FULL HOUSE', 'PAIR'] },
      { color: 'blue',   name: '___ HOUSE',        words: ['POWER', 'TREE', 'WARE', 'FARM'] },
      { color: 'purple', name: 'WORDS HIDING A NUMBER', words: ['OFTEN', 'STONE', 'FORTUNE', 'TENNIS'] },
    ],
  },
  {
    id: 10,
    categories: [
      { color: 'yellow', name: 'THINGS WITH KEYS',   words: ['PIANO', 'LOCK', 'CAR', 'MAP'] },
      { color: 'green',  name: 'TYPES OF BREAD',     words: ['BAGEL', 'BAGUETTE', 'NAAN', 'PITA'] },
      { color: 'blue',   name: 'FAMOUS LANDMARKS',   words: ['COLOSSEUM', 'PARTHENON', 'ACROPOLIS', 'PANTHEON'] },
      { color: 'purple', name: 'WORDS AFTER "FIRE"', words: ['WORK', 'PLACE', 'SIDE', 'ARMS'] },
    ],
  },
];

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

/* ── Share Modal ──────────────────────────────────────────────────────────── */
function ShareModal({ guessHistory, puzzle, gameStatus, onClose, onNewGame }) {
  const [copied, setCopied] = useState(false);

  const lines = guessHistory.map(g =>
    g.words.map(word => {
      const cat = puzzle.categories.find(c => c.words.includes(word));
      return SHARE_EMOJI[cat ? cat.color : 'yellow'];
    }).join('')
  );
  const resultLine = gameStatus === 'won'
    ? `✅ Solved in ${guessHistory.length} guess${guessHistory.length !== 1 ? 'es' : ''}!`
    : `❌ Out of guesses!`;
  const shareText = `🔗 WordZingo Connections\nPuzzle #${puzzle.id}\n\n${lines.join('\n')}\n\n${resultLine}\n🎮 wordzingo.com/connections`;
  const encText = encodeURIComponent(shareText);

  function copy() {
    navigator.clipboard.writeText(shareText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  }

  const SHARE_BTNS = [
    { label: '𝕏',  bg: '#000',    href: `https://twitter.com/intent/tweet?text=${encText}` },
    { label: '💬', bg: '#25d366', href: `https://wa.me/?text=${encText}` },
    { label: 'f',  bg: '#1877f2', href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent('https://wordzingo.com/connections')}` },
  ];

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: '1rem',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff', borderRadius: 18, padding: '1.4rem 1.4rem 1.1rem',
          maxWidth: 320, width: '100%', boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
          textAlign: 'center', position: 'relative',
        }}
        onClick={e => e.stopPropagation()}
      >
        <button onClick={onClose} style={{
          position: 'absolute', top: 10, right: 12, background: 'none',
          border: 'none', fontSize: '1.2rem', color: '#9ca3af', cursor: 'pointer',
        }}>✕</button>

        <div style={{ fontSize: '2rem', marginBottom: 4 }}>
          {gameStatus === 'won' ? '🎉' : '😔'}
        </div>
        <div style={{ fontWeight: 800, fontSize: '1.15rem', color: '#1e1b4b', marginBottom: 8 }}>
          {gameStatus === 'won' ? 'Puzzle Solved!' : 'Better luck next time!'}
        </div>

        <div style={{
          background: '#f1f5f9', borderRadius: 10, padding: '0.7rem',
          marginBottom: '0.6rem', fontFamily: 'monospace', fontSize: '1.1rem',
          lineHeight: 1.9, letterSpacing: 3, minHeight: 48,
        }}>
          {lines.map((l, i) => <div key={i}>{l}</div>)}
        </div>

        <div style={{ fontSize: '0.8rem', color: '#475569', marginBottom: '0.8rem', fontWeight: 600 }}>
          {resultLine}
        </div>

        <button onClick={copy} style={{
          width: '100%', borderRadius: 50, border: 'none', padding: '0.55rem',
          fontWeight: 700, fontFamily: 'Nunito, sans-serif', fontSize: '0.88rem',
          marginBottom: '0.5rem', cursor: 'pointer',
          background: copied ? '#10b981' : '#4f46e5', color: '#fff', transition: 'background 0.2s',
        }}>
          {copied ? '✓ Copied!' : '📋 Copy Result'}
        </button>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: '0.8rem' }}>
          {SHARE_BTNS.map(({ label, bg, href }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer" style={{
              width: 40, height: 40, borderRadius: '50%', background: bg,
              color: '#fff', textDecoration: 'none', fontWeight: 800, fontSize: '0.85rem',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>{label}</a>
          ))}
        </div>

        <button onClick={() => { onNewGame(); onClose(); }} style={{
          borderRadius: 50, border: '1.5px solid #e2e8f0', background: 'none',
          padding: '0.38rem 1rem', fontWeight: 700, fontFamily: 'Nunito, sans-serif',
          fontSize: '0.82rem', cursor: 'pointer', color: '#374151',
        }}>
          🔄 Next Puzzle
        </button>
      </div>
    </div>
  );
}

/* ── Main Component ───────────────────────────────────────────────────────── */
export default function Connections() {
  const [puzzleIdx, setPuzzleIdx] = useState(0);
  const puzzle = PUZZLES[puzzleIdx];

  const [words, setWords]           = useState(() => shuffle(PUZZLES[0].categories.flatMap(c => c.words)));
  const [selected, setSelected]     = useState([]);
  const [solved, setSolved]         = useState([]);
  const [mistakes, setMistakes]     = useState(0);
  const [message, setMessage]       = useState('');
  const [gameStatus, setGameStatus] = useState('playing');
  const [guessHistory, setGuessHistory] = useState([]);
  const [showShare, setShowShare]   = useState(false);
  const [shaking, setShaking]       = useState(false);

  function startGame(idx) {
    const p = PUZZLES[idx];
    setPuzzleIdx(idx);
    setWords(shuffle(p.categories.flatMap(c => c.words)));
    setSelected([]);
    setSolved([]);
    setMistakes(0);
    setMessage('');
    setGameStatus('playing');
    setGuessHistory([]);
    setShowShare(false);
  }

  function newGame() {
    startGame((puzzleIdx + 1) % PUZZLES.length);
  }

  function showMsg(msg, duration = 2200) {
    setMessage(msg);
    setTimeout(() => setMessage(''), duration);
  }

  function toggleWord(word) {
    if (gameStatus !== 'playing') return;
    setSelected(prev => {
      if (prev.includes(word)) return prev.filter(w => w !== word);
      if (prev.length >= 4) return prev;
      return [...prev, word];
    });
  }

  function submit() {
    if (selected.length !== 4 || gameStatus !== 'playing') return;

    const match = puzzle.categories.find(
      cat => !solved.includes(cat.color) && selected.every(w => cat.words.includes(w))
    );

    const newHistory = [...guessHistory, { words: [...selected] }];
    setGuessHistory(newHistory);
    setSelected([]);

    if (match) {
      const newSolved = [...solved, match.color];
      setSolved(newSolved);
      setWords(prev => prev.filter(w => !match.words.includes(w)));

      if (newSolved.length === 4) {
        setGameStatus('won');
        showMsg('Brilliant! You got them all! 🎉', 2500);
        setTimeout(() => setShowShare(true), 2200);
      } else {
        showMsg(`Correct! "${match.name}" ✅`);
      }
    } else {
      const oneAway = puzzle.categories.some(
        cat => !solved.includes(cat.color) &&
               selected.filter(w => cat.words.includes(w)).length === 3
      );
      const newMistakes = mistakes + 1;
      setMistakes(newMistakes);
      setShaking(true);
      setTimeout(() => setShaking(false), 500);

      if (newMistakes >= MAX_MISTAKES) {
        setGameStatus('lost');
        showMsg('Out of guesses! See the answers below 😔', 2500);
        setTimeout(() => setShowShare(true), 2200);
      } else {
        showMsg(oneAway ? '😬 One away...' : '❌ Not quite! Try again.');
      }
    }
  }

  const solvedCategories = COLOR_ORDER
    .filter(c => solved.includes(c))
    .map(c => puzzle.categories.find(cat => cat.color === c));

  return (
    <div className="game-page">
      <PageSEO page="connections" />

      {showShare && (
        <ShareModal
          guessHistory={guessHistory}
          puzzle={puzzle}
          gameStatus={gameStatus}
          onClose={() => setShowShare(false)}
          onNewGame={newGame}
        />
      )}

      <div className="container" style={{ maxWidth: 560 }}>
        <Link to="/" className="back-btn"><i className="bi bi-arrow-left"></i> All Games</Link>

        <div className="game-header">
          <span className="game-icon">🔗</span>
          <h1>Connections</h1>
          <p>Group 16 words into 4 secret categories</p>
        </div>

        {/* How to play */}
        <div style={{
          background: '#f8fafc', border: '1.5px solid var(--border)',
          borderRadius: 12, padding: '0.65rem 1rem', marginBottom: '1rem',
          fontSize: '0.82rem', color: '#475569', lineHeight: 1.6,
        }}>
          <strong style={{ color: '#1e1b4b' }}>How to play:</strong> Find 4 groups of 4 words
          that share something in common. Select 4 words and tap <strong>Submit</strong>.
          You get <strong>4 lives</strong>. 🟨 Easy → 🟪 Fiendish.
        </div>

        {/* Toast message */}
        {message && (
          <div className="text-center fw-bold py-2 px-3 rounded-3 mb-3"
            style={{ background: '#1e1b4b', color: '#fff', fontSize: '0.95rem' }}>
            {message}
          </div>
        )}

        {/* Lives */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: '1rem' }}>
          <span style={{ fontWeight: 700, fontSize: '0.85rem', color: '#6b7280' }}>Lives:</span>
          <div style={{ display: 'flex', gap: 6 }}>
            {Array.from({ length: MAX_MISTAKES }, (_, i) => (
              <div key={i} style={{
                width: 14, height: 14, borderRadius: '50%',
                background: i < (MAX_MISTAKES - mistakes) ? '#4f46e5' : '#e2e8f0',
                border: `2px solid ${i < (MAX_MISTAKES - mistakes) ? '#4338ca' : '#d1d5db'}`,
                transition: 'all 0.35s',
              }} />
            ))}
          </div>
        </div>

        {/* Solved category banners */}
        {solvedCategories.map(cat => (
          <div key={cat.color} style={{
            background: CATEGORY_COLORS[cat.color].bg,
            borderRadius: 12, padding: '0.8rem 1rem',
            marginBottom: '0.5rem', textAlign: 'center',
          }}>
            <div style={{ fontSize: '0.65rem', fontWeight: 800, opacity: 0.6, textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 2 }}>
              {DIFFICULTY_LABEL[cat.color]}
            </div>
            <div style={{ fontSize: '1rem', fontWeight: 800, letterSpacing: 0.5 }}>{cat.name}</div>
            <div style={{ fontSize: '0.78rem', fontWeight: 700, marginTop: 3, opacity: 0.8 }}>
              {cat.words.join(' · ')}
            </div>
          </div>
        ))}

        {/* Word grid */}
        {gameStatus !== 'lost' && words.length > 0 && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, marginBottom: '1rem' }}>
            {words.map(word => {
              const isSel = selected.includes(word);
              return (
                <button
                  key={word}
                  onClick={() => toggleWord(word)}
                  className={shaking && isSel ? 'shake' : ''}
                  style={{
                    background: isSel ? '#1e1b4b' : '#fff',
                    color: isSel ? '#fff' : '#1e1b4b',
                    border: `2px solid ${isSel ? '#1e1b4b' : '#e0e7ff'}`,
                    borderRadius: 10,
                    padding: '0.6rem 0.2rem',
                    fontWeight: 800,
                    fontSize: '0.74rem',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    fontFamily: 'Nunito, sans-serif',
                    textTransform: 'uppercase',
                    letterSpacing: 0.3,
                    minHeight: 56,
                    transform: isSel ? 'scale(1.05)' : 'scale(1)',
                    lineHeight: 1.2,
                  }}
                >
                  {word}
                </button>
              );
            })}
          </div>
        )}

        {/* Reveal all categories when lost */}
        {gameStatus === 'lost' && (
          <div style={{ marginBottom: '1rem' }}>
            {COLOR_ORDER.map(color => {
              const cat = puzzle.categories.find(c => c.color === color);
              return (
                <div key={color} style={{
                  background: CATEGORY_COLORS[color].bg,
                  borderRadius: 12, padding: '0.8rem 1rem',
                  marginBottom: '0.5rem', textAlign: 'center',
                  opacity: solved.includes(color) ? 1 : 0.72,
                }}>
                  <div style={{ fontSize: '0.65rem', fontWeight: 800, opacity: 0.6, textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 2 }}>
                    {DIFFICULTY_LABEL[color]}
                  </div>
                  <div style={{ fontSize: '1rem', fontWeight: 800 }}>{cat.name}</div>
                  <div style={{ fontSize: '0.78rem', fontWeight: 700, marginTop: 3, opacity: 0.8 }}>
                    {cat.words.join(' · ')}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Playing controls */}
        {gameStatus === 'playing' && (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', marginBottom: '1.5rem' }}>
            <button
              onClick={() => setWords(w => shuffle([...w]))}
              style={{
                borderRadius: 50, border: '2px solid #e0e7ff', background: '#fff',
                padding: '0.45rem 1.1rem', fontWeight: 700, fontFamily: 'Nunito, sans-serif',
                fontSize: '0.82rem', cursor: 'pointer', color: '#475569',
              }}
            >🔀 Shuffle</button>
            <button
              onClick={() => setSelected([])}
              disabled={selected.length === 0}
              style={{
                borderRadius: 50, border: '2px solid #e0e7ff', background: '#fff',
                padding: '0.45rem 1.1rem', fontWeight: 700, fontFamily: 'Nunito, sans-serif',
                fontSize: '0.82rem', cursor: selected.length ? 'pointer' : 'not-allowed',
                color: selected.length ? '#475569' : '#d1d5db',
              }}
            >Deselect All</button>
            <button
              onClick={submit}
              disabled={selected.length !== 4}
              style={{
                borderRadius: 50, border: 'none',
                background: selected.length === 4 ? '#1e1b4b' : '#e2e8f0',
                color: selected.length === 4 ? '#fff' : '#9ca3af',
                padding: '0.45rem 1.5rem', fontWeight: 700, fontFamily: 'Nunito, sans-serif',
                fontSize: '0.82rem', cursor: selected.length === 4 ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s',
              }}
            >Submit</button>
          </div>
        )}

        {/* End-game controls */}
        {gameStatus !== 'playing' && (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', marginBottom: '1.5rem' }}>
            <button onClick={newGame} className="solve-btn">🔄 Next Puzzle</button>
            <button
              onClick={() => setShowShare(true)}
              style={{
                borderRadius: 50, border: 'none', background: '#4f46e5', color: '#fff',
                padding: '0.55rem 1.2rem', fontWeight: 700, fontFamily: 'Nunito, sans-serif',
                fontSize: '0.85rem', cursor: 'pointer',
              }}
            >📤 Share Result</button>
          </div>
        )}

        {/* Puzzle counter */}
        <div style={{ textAlign: 'center', marginBottom: '1rem', fontSize: '0.78rem', color: '#9ca3af', fontWeight: 600 }}>
          Puzzle #{puzzle.id} of {PUZZLES.length} ·{' '}
          <button onClick={newGame} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#4f46e5', fontWeight: 700, fontSize: '0.78rem', fontFamily: 'Nunito, sans-serif',
          }}>Next Puzzle →</button>
        </div>

        <SeoContent game="connections" />
      </div>
    </div>
  );
}
